import { useMutation } from '@apollo/client';
import { DELETE_OBJECTIVE_MUTATION } from '../../mutations';

export function useDeleteObjectiveMutation() {
    return useMutation( DELETE_OBJECTIVE_MUTATION );
}
